module.exports = __webpack_public_path__ + "static/media/5.b6c16189.jpg";